import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
	IBellNotificationPayload,
	IBellNotifications,
} from '@app/services/notifications-bell/models/notifcations-bell-models';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { InAppEndpoints } from '@app/services/notifications-bell/consts';

@Injectable({
	providedIn: 'root',
})
export class NotificationsBellApiService {
	constructor(private apiFacade: ApiFacadeService) {}

	public fetchBellNotifications(): Observable<IBellNotifications> {
		return this.apiFacade.get<IBellNotifications>(InAppEndpoints.GetAll);
	}

	public dismissNotification(notificationPayload: IBellNotificationPayload | {}): Observable<{}> {
		return this.apiFacade.post<{}>(InAppEndpoints.Dismiss, notificationPayload);
	}
}
